import { Formik } from "formik";
import Info from "./sections/info";
import PageHeader from "components/Shared/PageHeader";
import { Container, Divider } from "@mui/material";
import AccountingCode from "./sections/accountingCode";
import MaterialsList from "./sections/materials/materials";
import OtherCosts from "./sections/other";
import Footer from "./sections/footer";
import shortid from "shortid";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { apiGetManufactureFormula } from "api/manufactureFormulaApi";
import { useAppSelector } from "store/store";

const initialRows: MaterialsRow[] = [{ ind: shortid.generate() }, { ind: shortid.generate() }];
const init: MaterialFormulaData = {
  isEdit: false,
  costType: "price",
  wageType: "price",
  materialsRows: initialRows,
};

export default function MaterialFormulaForm() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const store = useAppSelector((x) => x);
  const token = store.businessReducer.business.token;
  const { id } = useParams() ?? { id: undefined };
  const [initialFormData, setInitialFormData] = useState<MaterialFormulaData>(init);

  useEffect(() => {
    if (id !== undefined && token !== undefined) {
      dispatch(
        //@ts-ignore
        apiGetManufactureFormula(id, token, (formula: ManufactureFormula) => {
          try {
            setInitialFormData({
              isEdit: true,
              materialsRows: formula.Production_Formula_Items.map((item) => {
                return {
                  ind: shortid.generate(),
                  productId: item.ProductId,
                  quantity: item.quantity,
                  unit: item.unit,
                  units: [item.Product.unit].flatMap((x) =>
                    item.Product.subUnit ? [x, item.Product.subUnit] : [x]
                  ),
                };
              }),
              cost: formula.estimateCost,
              costType: formula.estimateCostType,
              wage: formula.estimateWage,
              wageType: formula.estimateWageType,
              product: formula.Product,
              productId: formula.ProductId,
              title: formula.title,
            });
          } catch (error) {
            setLoading(false);
          }
        })
      );
    }
    setLoading(false);
  }, [id]);

  return (
    <>
      {!loading && (
        <Formik initialValues={initialFormData} onSubmit={() => {}} enableReinitialize>
          <Container maxWidth="lg" className="relative">
            <PageHeader heading="فرمول ساخت جدید" actionSection={<></>} />
            <div className="pb-10 mb-6 bg-white rounded-md md:px-32">
              <AccountingCode />
              <Divider />
              <Info />
              <Divider className="my-10" />
              <MaterialsList />
              <Divider className="my-10" />
              <OtherCosts />
            </div>
            <Footer />
          </Container>
        </Formik>
      )}
    </>
  );
}
